import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';
// 상점 관리 > 상점 그룹별 라이더 수수료 그룹 설정 페이지 > 상점 설정(store-setting) 다이얼로그
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
